import { browserRoutes } from 'constants/routes';
import useSelector from 'hooks/useSelector';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as LearningIcon } from 'static/icons/brainstorming.svg';
import { ReactComponent as CollectionIcon } from 'static/icons/icons-folder-ok.svg';
import { ReactComponent as EmployeeCentralIcon } from 'static/icons/operation-crew.svg';
import { ReactComponent as HomeIcon } from 'static/icons/portal.svg';
import { ReactComponent as WgptIcon } from 'static/icons/robot-face-smile-default.svg';
import { ReactComponent as TeamIcon } from 'static/icons/three-persons.svg';

import { useAdUser } from '../../../AuthContext';

export interface Route {
    to: string;
    text: string | React.ReactElement<any>;
    icon: React.ReactElement<any>;
}

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
}

export const useRoutes = (): Route[] => {
    const profile = useSelector((state) => state.user.profile.data);
    const subordinates = useSelector((state) => state.user.subordinates);
    const { isAdmin } = useAdUser();

    return [
        {
            to: `/${browserRoutes.home}`,
            icon: <HomeIcon />,
            text: <FormattedMessage id="view_name.my_hr_portal" />,
        },
        {
            to: `/${browserRoutes.myLearning}`,
            icon: <LearningIcon />,
            text: <FormattedMessage id="view_name.my_learning" />,
        },
        (profile.isManager && subordinates.data?.length !== 0) || isAdmin
            ? {
                  to: `/${browserRoutes.myTeam}`,
                  icon: <TeamIcon />,
                  text: <FormattedMessage id="view_name.my_team" />,
              }
            : null,
        {
            to: `/${browserRoutes.collection}`,
            icon: <CollectionIcon />,
            text: <FormattedMessage id="view_name.zendesk_knowledge" />,
        },
        {
            /* Success Factors SideBar Link */
            to: `https://performancemanager.successfactors.eu/sf/home?company=Wartsila`,
            icon: <EmployeeCentralIcon />,
            text: <FormattedMessage id="view_name.my_hr_employee_central" />,
        },
        {
            to: `https://wgpt-chat.app.wartsila.com/myhr-chat`,
            icon: <WgptIcon />,
            text: <FormattedMessage id="view_name.wgpt_chat" values={{ br: <br /> }} />,
        }
    ].filter(notEmpty);
};
